import './PerformanceMetrics.css';

export default function PerformanceMetrics({ rate = 85, delay = 7 }) {
  return (
    <div className="performance-metrics">
      <h4>Performance du mois</h4>
      <div className="metric">
        <div className="metric-header">
          <span>Taux de validation</span>
          <strong>{rate}%</strong>
        </div>
        <div className="bar">
          <span style={{ width: `${rate}%` }} />
        </div>
      </div>
      <div className="metric">
        <div className="metric-header">
          <span>Délai moyen</span>
          <strong>{delay} jours</strong>
        </div>
        <div className="bar warning">
          <span style={{ width: `${Math.min(delay * 10, 100)}%` }} />
        </div>
      </div>
    </div>
  );
}
